function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2026 2937c-31 0-56-25-56-56s25-56 56-56h388l-197-820h-380c-31 0-56-25-56-56v-291h-375c-86 0-164-35-221-92-33-33-58-72-74-116H721c-22 0-43-9-57-24-2-2-3-4-5-6-12-14-19-32-19-52v-272H1c-31 0-56-25-56-56s25-56 56-56h639V728c0-22 9-43 24-57 15-15 35-24 57-24h378c12-63 43-119 86-162 57-57 135-92 221-92h1352c174 0 332 71 446 185s185 272 185 446-71 332-185 446-272 185-446 185h-99l336 1190c7 9 10 20 10 32 0 31-25 56-56 56h-923zm-933-1597V761H750v579h343zm111-626c1 6 2 11 2 17v642c6 45 27 85 57 115 36 36 87 59 142 59h375V506h-375c-55 0-106 23-142 59s-59 87-59 142v6zm687-207v1041h866c143 0 273-59 367-153s153-224 153-367-59-273-153-367-224-153-367-153h-866zm0 1152v236h298l-57-236h-241zm356 3l278 1155h345l-326-1155h-297z",
  fillRule: "nonzero"
});

var SvgDrill = function SvgDrill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3333 3333",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drill.df35486d.svg";
export { ForwardRef as ReactComponent };